import Hero from "../components/Hero";
import QuoteForm from "../components/QuoteForm";
import Languages from "../components/Languages";
import TrustedCompanies from "../components/TrustedCompanies";
import Services from "../components/Services";
import GlobalMap from "../components/GlobalMap";
import Testimonials from "../components/Testimonials";
import AboutUs from "../components/AboutUs";
import PaymentMethods from "../components/PaymentMethods";

export default function Home() {
    return (
        <main>
            <Hero />
            <TrustedCompanies />
            <Services />
            <QuoteForm />
            <Languages />
            <GlobalMap />
            <Testimonials />
            <AboutUs />
            <PaymentMethods />
        </main>
    );
}
